import { INTERACTIONS, SCENARIOS } from '../constants/Constants';
import { KEYS } from '../constants/SceneConstants';

export class ShortcutController {
  constructor(game, shortcutcontroller, autoshow) {
    this._game = game;
    this._shortcutController = shortcutcontroller;
    shortcutcontroller.enable();
    this.addBaseShortcuts();
    if (autoshow) shortcutcontroller.show();
    else shortcutcontroller.hide();
  }

  addBaseShortcuts() {
    this.addGameShortcuts(this._game);
    this.addAppShortcuts(this._game);
    this.addScenarioSelectShortcuts(this._game);
    this.addInteractiveSelectShortcuts(this._game);
  }

  addGameShortcuts(game) {
    this._shortcutController.addDisplayField({
      id: 'game',
      group: 'game',
      title: `Version:`,
      value: `${JW_VERSION}`,
    });
  }

  addAppShortcuts(game) {
    this._shortcutController.addShortcutGroup({
      id: 'player',
      group: 'player',
      title: 'Player',
      open: false,
    });
    this._shortcutController.addShortcut({
      group: 'player',
      field: 'cleardata',
      title: 'Clear Saved Data',
      value: () => {
        localStorage.clear();
        window.location.reload();
      },
    });
    this._shortcutController.addShortcut({
      group: 'player',
      field: 'unlocktoybox',
      title: 'Unlock Toybox Items',
      value: () => {
        INTERACTIONS.forEach((interaction) => game.player.addToToybox(interaction.id));
        window.location.reload();
      },
    });
  }

  addScenarioSelectShortcuts(game) {
    this._shortcutController.addShortcutGroup({
      id: 'scenarios',
      group: 'scenarios',
      title: 'Scenarios',
      open: false,
    });
    SCENARIOS.forEach((scenario) => {
      if (scenario.active) {
        this._shortcutController.addShortcut({
          group: 'scenarios',
          field: scenario.id,
          title: scenario.name,
          value: () => game.launchScenario(scenario.id),
        });
      }
    });
  }

  addInteractiveSelectShortcuts(game) {
    this._shortcutController.addShortcutGroup({
      id: 'interactions',
      group: 'interactions',
      title: 'Interactions',
      open: false,
    });
    INTERACTIONS.forEach((interaction) => {
      this._shortcutController.addShortcut({
        group: 'interactions',
        field: interaction.id,
        title: interaction.name,
        value: () => game.launchInteraction(interaction.id),
      });
    });
  }

  addScenarioShortcuts(game) {
    this._shortcutController.addShortcutGroup({
      id: 'scenario',
      group: 'scenario',
      title: 'Scenario Control',
      open: false,
    });
    this._shortcutController.addShortcut({
      group: 'scenario',
      field: 'nextstate',
      title: 'Next State',
      value: () => this._game.sceneController.getScene(KEYS.Scenario).nextState(),
    });
    this._shortcutController.addShortcut({
      group: 'scenario',
      field: 'prevstate',
      title: 'Prev State',
      value: () => this._game.sceneController.getScene(KEYS.Scenario).previousState(),
    });
  }

  clearScenarioShortcuts() {
    this._shortcutController.reset();
    this._shortcutController.addShortcutGroup({
      id: 'game',
      group: 'game',
      title: 'Game',
      open: false,
    });
    this.addBaseShortcuts();
  }
}
